import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { Product } from 'src/app/models/interface/product/product';
import { FtthService } from 'src/app/services/api/ftth/ftth.service';
import { NotificationLevel, NotificationsService } from 'src/app/services/api/notifications/notifications.service';
import { ProductDepthLevelProductActionsComponent } from '../product-depth-level-product-actions.component';

@Component({
  selector: 'app-install',
  templateUrl: './install.component.html',
  styleUrls: ['./install.component.scss']
})
export class InstallComponent implements OnInit {

  item: Product;
  loading: boolean;

  private subscriptions = new Subscription();

  reutilizaacometida: boolean;

  constructor(
    private ftthService: FtthService,
    private notificationsService: NotificationsService,
    private translateService: TranslateService,
    private dialogRef: MatDialogRef<ProductDepthLevelProductActionsComponent>,
    @Inject(MAT_DIALOG_DATA) private data: {
      item: Product;
      type: string;
    },
  ) {

  }

  ngOnInit() {

    this.reutilizaacometida = false;

    this.loading = false;
    this.item = this.data.item;

    if (this.data.type !== 'product') {
      throw new Error('It must be a product');
    }
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  install() {
    this.loading = true;
    this.ftthService.installation({
      'operador': this.item.origin,
      'idadministrativo': this.item.productCharValues.find(charValue => charValue.specId === "pc_ftth_service_id").value,
      'codigocto': this.item.cfses[0].cfsCharValues.find(charValue => charValue.specId === "sc_network_cto_code").value,
      'posicionsplitter': parseInt(this.item.cfses[0].cfsCharValues.find(charValue => charValue.specId === "sc_network_splitter_location").value),
      'reutilizaacometida': this.reutilizaacometida ? 'S' : 'N',
      'propietarioacometida': this.item.cfses[0].cfsCharValues.find(charValue => charValue.specId === "sc_network_drop_cable_owner").value
    })
      .subscribe(
        (data) => {
          this.loading = false;
          if (data.resultado === 'OK') {
            this.dialogRef.close(true);
            this.notificationsService.showNotification(this.translateService.instant('INSTALL_PRODUCT.success'), NotificationLevel.SUCCESS);
          }
          else {
            this.notificationsService.showNotification("ERROR (" + data.codResultado + "): " + data.descResultado, NotificationLevel.ERROR);
          }
        },
        error => {
          this.loading = false;
          this.notificationsService.showNotification("ERROR (" + error.data.codResultado + "): " + error.data.descResultado, NotificationLevel.ERROR);
        }
      );

  }

}
